import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import HomePage from './pages/home/page';
import ServicosPage from './pages/servicos/page';
import ServicoDetalhePage from './pages/servicos/[slug]/page';
import PortfolioPage from './pages/portfolio/page';
import ContatoPage from './pages/contato/page';
import ComoFuncionaPage from './pages/como-funciona/page';

import AdminLogin from './pages/admin/login/page';
import AdminDashboard from './pages/admin/dashboard/page';
import AdminPortfolio from './pages/admin/portfolio/page';
import AdminProducts from './pages/admin/produtos/page';

import { AdminAuthProvider } from './contexts/AdminAuthContext';

function App() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />

          <Route path="/servicos" element={<ServicosPage />} />
          <Route path="/servicos/:slug" element={<ServicoDetalhePage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/contato" element={<ContatoPage />} />
          <Route path="/como-funciona" element={<ComoFuncionaPage />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/portfolio" element={<AdminPortfolio />} />
          <Route path="/admin/produtos" element={<AdminProducts />} />
          <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
        </Routes>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}

export default App;